<template>
  <div>
    <router-link
      :to="{ name: option.path }"
      :class="setTheme"
      class="focus:outline-none group flex rounded-md items-center w-full px-2 py-2 text-sm"
    >
      <base-icon v-if="option.icon" :name="option.icon" class="mr-2" />
      {{ option.name }}
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'item-nav',
  props: {
    option: {
      type: [Array, Object],
      required: true
    },
    theme: {
      type: String,
      default: 'light'
    }
  },
  computed: {
    setTheme: function () {
      return {
        'bg-white hover:bg-primary-50 hover:text-primary active:bg-primary-100':
          this.theme === 'light',
        'bg-secondary text-white hover:bg-secondary-900 active:bg-secondary focus:bg-secondary-900':
          this.theme === 'dark'
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
